module.exports = __webpack_public_path__ + "static/media/about-us-lolipop.51ea0b22.webp";